'use strict';

const isSmallView = require('./modules/helpers/isSmallView');

function toggleSeo() {
    // SEO text block - expand / collapse
    $(document).on('click','.js-seo-text-toggle', function () {
        const $parentSeoBlock = $(this).closest('.wrapper__seo-block');

        if (!$parentSeoBlock.hasClass('expanded')) {
            $parentSeoBlock.addClass('expanded');
            if ($parentSeoBlock.find('.text__container a').length) {
                $parentSeoBlock.find('.text__container a').attr('tabindex', '0');
            }
        } else {
            $parentSeoBlock.removeClass('expanded');
            if (isSmallView()) {
                $('html, body').animate({scrollTop: ($parentSeoBlock.offset().top - 90)}, 600);
            }
            if ($parentSeoBlock.find('.text__container a').length) {
                $parentSeoBlock.find('.text__container a').attr('tabindex', '-1');
            }
        }
    });
}

function accessibilityAdjustments() {
    if ($('.wrapper__seo-block').length) {
        $('.wrapper__seo-block').each(function () {
            if ($(this).hasClass('expanded') && $(this).find('.text__container a').length) {
                $(this).find('.text__container a').attr('tabindex', '-1');
            }
        });

        $('.js-seo-text-toggle').attr('tabindex', '0');
    }
}

function initializeEvents() {
    toggleSeo();
    accessibilityAdjustments();
}

const seoText = {
    init: function() {
        initializeEvents();
    }
};

module.exports = seoText;
